module.exports = "/_next/static/images/video-a5fa334a7310991459eb9f79c81a482b.svg";